export default __webpack_public_path__ + "static/media/navigation-bottom.fbc44a28.png";